import { Component, OnInit } from '@angular/core';
import { OrderItemModel, OrderModel } from '../../core/models';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { OrderService } from '../../services/order/order.service';

@Component({
  selector: 'app-customer-purchases',
  templateUrl: './customer-purchases.component.html',
  styleUrls: ['./customer-purchases.component.scss']
})
export class CustomerPurchasesComponent implements OnInit {
  // Customer order rows.
  orders: OrderModel[] = [];

  // Selected order for view details modal.
  selectedOrder: OrderModel | null = null;

  // Dialog visibility.
  showOrderDetails = false;

  // Component dependencies.
  constructor(private orderService: OrderService, private invoiceService: InvoiceService) {}

  // Load customer purchases.
  loadPageData(): void { this.orderService.getMyOrders().subscribe(x => this.orders = x || []); }

  // Open order details modal.
  viewOrderDetails(order: OrderModel): void {
    this.selectedOrder = order;
    this.showOrderDetails = true;
  }

  // Download invoice for selected order.
  downloadInvoice(order: OrderModel): void {
    this.invoiceService.downloadInvoice(this.invoiceService.buildFromOrder(order));
  }

  // Get display items for selected order.
  getOrderItems(order: OrderModel | null): OrderItemModel[] {
    if (!order) return [];
    return order.items?.length ? order.items : [{ courseId: 0, courseName: 'Course booking', quantity: 1, unitPrice: Number(order.totalAmount || 0), lineAmount: Number(order.totalAmount || 0) }];
  }

  // Component init.
  ngOnInit(): void { this.loadPageData(); }
}
